import { render, staticRenderFns } from "./Yiting.vue?vue&type=template&id=4414d06a&scoped=true"
import script from "./Yiting.vue?vue&type=script&lang=js"
export * from "./Yiting.vue?vue&type=script&lang=js"
import style0 from "./Yiting.vue?vue&type=style&index=0&id=4414d06a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414d06a",
  null
  
)

export default component.exports